import { Modal } from "antd";
import { useSelector } from "react-redux";
import { NicknameTable } from "../Settings/NicknameTable";

export const NicknameDialog = ({
  open,
  onCancel,
  missingPlayerName
}) => {

  const {
    allPlayers
  } = useSelector(({ team }) => team);

  const modalTitle = 'Add a nickname';

  return (
    <Modal
      open={open}
      title={modalTitle}
      onCancel={onCancel}
      footer={null}
      width={600}
      style={{ top: 120 }}
    >
      <div className="nickname-table-container">
        <NicknameTable
          players={allPlayers}
          missingPlayerName={missingPlayerName}
          modalMode={true}
        />
      </div>
    </Modal>
  );
};
